module.exports = __webpack_public_path__ + "media/images/item/reco_bg_btm-0bc290ddeac42ae1dc9b67400cb9357a.gif";